import React from "react";
import { Link } from "react-router-dom";

function Modal({ test_id, subject_id, open, testNatija, size, testOrder, onClose }) {
    if (!open) return null;
    var buttons = []
    let values = Object.keys(testNatija.error);
    testOrder.forEach(function (value, index) {

        if (values.includes(value.toString())) {
            let style = { backgroundColor: "red", color: "white" }
            buttons.push(<button key={index} style={style}>{index + 1}</button>)
        } else {
            let style = { backgroundColor: "green", color: "white" }
            buttons.push(<button key={index} style={style}>{index + 1}</button>)
        }
    });
    if(subject_id=='umumiy'){
        return (
            <div className="overlay">
                <div className="test-timer">
                    <p>TEST NATIJASI</p>
                    <div className="modalRight">
                        <h6 onClick={onClose} className="closeBtn">
                            X
                        </h6>
                    </div>
                    <div className="test-buttons">
                        {buttons.map((test) => {
                            return (
                                <p>{test}</p>
                            )
                        })}
                    </div>
    
                    <div className="bottomBtn">
                        <button className="btn"><Link to={`/`}>Bosh sahifa</Link></button> <br />
                        <span>Test toplagan ball: {testNatija.result} </span>
                    </div>
                </div>
            </div>
        );
    }else{
        return (
            <div className="overlay">
                <div className="test-timer">
                    <p>TEST NATIJASI</p>
                    <div className="modalRight">
                        <h6 onClick={onClose} className="closeBtn">
                            X
                        </h6>
                    </div>
                    <div className="test-buttons">
                        {buttons.map((test) => {
                            return (
                                <p>{test}</p>
                            )
                        })}
                    </div>
    
                    <div className="bottomBtn">
                        <button className="btn"><Link to={`/boshlangich-talim/${test_id}/${subject_id}/`}>Bosh sahifa</Link></button> <br />
                        <span>Test toplagan ball: {testNatija.result} </span>
                    </div>
                </div>
            </div>
        );
    }
}

export default Modal;